import {CALL_API} from 'redux-api-middleware';
import {
  API_APPLICATION_GET_REQUEST,
  API_APPLICATION_GET_SUCCESS,
  API_APPLICATION_GET_FAILURE,
} from 'common/types';
import {ENDPOINT_DYNAMIC_DATA} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  getApplication: (token, id) => {
    return {
      [CALL_API]: {
        endpoint:
          ENDPOINT_DYNAMIC_DATA +
          'entities/first-entity?entityType=application&grantId' +
          id,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_APPLICATION_GET_REQUEST,
          API_APPLICATION_GET_SUCCESS,
          API_APPLICATION_GET_FAILURE,
        ],
      },
    };
  },
};
